export default __webpack_public_path__ + "static/media/oper.2fc53f65.png";